module.exports = __webpack_public_path__ + "img/dhrw.49a1f97c.svg";